export const LOCATION_ENTITY                            = 'location';
export const LOCATION_RULE_ENTITY                       = 'locationRule';

export const SCHEDULE_ENTITY                            = 'schedule';

export const DELIVERY_ORDER_ENTITY                      = 'deliveryOrder';
export const DELIVERY_ORDER_CONFIG_ENTITY               = 'deliveryOrderConfig';

export const DISPATCH_CONFIG_ENTITY                     = 'dispatchConfig';

export const DRIVER_ENTITY                              = 'driver';

export const API_KEY_ENTITY                             = 'apiKey';

export const BILLING_INVOICE_ENTITY                     = 'invoice';

export const USER_ENTITY                                = 'user';

export const DELIVERIES_BY_DRIVER_REPORT_ENTITY         = 'reportDeliveriesByDriver';